module.exports = __webpack_public_path__ + "img/rb.74c3e572.png";